import { Box, Container, styled, Typography } from "@mui/material";
import React from "react";

const AboutUs = () => {
  return (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <Box
        sx={{
          py: { xs: 3, md: 5 },
          px: { xs: 3, md: 5 },
          pt: { xs: 6, md: 4 },
          bgcolor: "#FFFFFF",
        }}
      >
        <Heading>About Us</Heading>

        <Para>
          Utsav Pack provides quality gift boxes, retail packaging, rigid
          boxes, and customised packaging solutions for every celebration and
          brand touchpoint. We focus on packaging that protects products and
          presents them beautifully.
        </Para>
        <Para>
          Our Story — At Utsav Pack, we believe that packaging is more than just
          a container — it is the first impression your brand makes. We offer a
          comprehensive range of packaging and printing services including
          custom boxes, labels, flexible packaging, corrugated solutions, and
          specialty print finishes. Our state-of-the-art facilities ensure
          precision, consistency, and scalability for businesses of all sizes,
          from startups to large enterprises. We work closely with our clients
          to understand their unique requirements and deliver tailored solutions
          that meet both aesthetic and functional needs.
        </Para>
        <Para>
          Our team of experienced professionals is committed to providing
          maximum efficiency, competitive pricing, and on-time delivery to our
          valued customers. Quality Packaging. Better Presentation. Happier Customers.
        </Para>
      </Box>
    </Box>
  );
};

export default AboutUs;
const Para = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontFamily: "Montserrat",
  fontWeight: 500,
  lineHeight: "22px",
  letterSpacing: "0%",
  textAlign: "justify",
  margin: "8px 0",
  marginLeft: "36px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px !important",
    marginLeft: "16px",
  },
}));
const Heading = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontFamily: "Montserrat",
  fontWeight: 700,
  lineHeight: "40px",
  letterSpacing: 0,
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "22px !important",
  },
}));
